import { render, staticRenderFns } from "./SalesOrdersReportsTable.vue?vue&type=template&id=4c6f28fb&"
import script from "./SalesOrdersReportsTable.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports